export const strings = {
	mainPage: {
		hello: {
			EN: "Hello!",
			CN: "哈囉！",
		},
		mainIntro: {
			EN: 'Hi, I\'m Evan! I am a Software Engineer based in Seattle, WA. I mostly work in React and am always trying and learning new things.',
			CN: '嗨，我是Evan！ 我是位軟體工程師。'
		},
		siteWelcome: {
			EN: 'Welcome to my site - here are a few things I\'m interested in!',
			CN: '歡迎來到我的網站！ 讓這些照片介紹一下我喜歡什麼。'
		},
		hikingCaption: {
			EN: 'Hiking around the PNW',
			CN: '在PNW附近爬山'
		},
		emailPrompt: {
			EN: 'Send me an email!',
			CN: '傳 E-mail 給我'
		},
		shadowCaption: {
			EN: 'Interior design for a cat\'s home',
			CN: '跟貓咪玩'
		},
		rockClimbingCaption: {
			EN: 'Rock climbing',
			CN: '攀岩'
		}
	},
	aboutPage: {
		title: {
			EN: 'About',
			CN: '自我介紹'
		},
		intro: {
			EN: 'Hi, I\'m Evan! I\'m a software engineer based in Seattle.',
			CN: '哈囉！我是Evan，我是位軟體工程師。'
		},
		graduatedMessage: {
			EN: 'recently graduated CSSE student from UWB', 
			CN: '最近從UWB畢業'
		},
		softwarePositionMessage: {
			EN: 'full-stack software developer',
			CN: 'full-stack 軟體工程師'
		},
		musicMessage: {
			EN: 'I love playing, making, and listening to music',
			CN: '喜歡做音樂'
		},
		sportsMessage: {
			EN: 'Avid rock climber and casual tennis player',
			CN: '我超喜歡攀岩跟打網球'
		},
		takeALook: {
			EN: 'take a look at my',
			CN: '看看我的'
		},
		followMessage: {
			EN: 'follow me on',
			CN: '追蹤我的'
		},
		recentRotation: {
			EN: 'In my recent rotation:',
			CN: '最近在聽的歌和播放清單:'
		},
	},
	general: {
		links: {
			EN: 'Links',
			CN: '連結'
		},
		resume: {
			EN: 'Resume',
			CN: '履歷'
		},
		photos: {
			EN: 'Photos',
			CN: '照片'
		},
		about: {
			EN: 'About',
			CN: '介紹'
		},
		home: {
			EN: 'Home',
			CN: '主頁'
		},
		music: {
			EN: 'Music',
			CN: '音樂'
		},
		download: {
			EN: 'Download',
			CN: '下載'
		}
	},
	resumePage: {
		experiences: {
			EN: 'Experiences',
			CN: '經驗'
		},
		responsibilities: {
			EN: 'Responsibilities',
			CN: '責任'
		}
	}
};
